// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyOutlinedSvg from "@fishx/icons-svg/es/asn/PropertySafetyOutlined";
import FishxIcon from '../components/FishxIcon';

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyOutlinedSvg
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
export default React.forwardRef(PropertySafetyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PropertySafetyOutlined.js
// module id = 3857
// module chunks = 0